import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { WrapAroundCarousel } from '@domain-group/fe-allhomes-nuka-carousel';
import Thumbnail from './thumbnail';
import Item from '../../models/item';
import * as styles from './thumbnails.style';
import logEventForComponent from '../../utils/log-event-for-component';
import { jsx as ___EmotionJSX } from "@emotion/core";
var logThumbEvent = logEventForComponent('ThumbWrapper');
var MAX_THUMBNAILS = 6;
var preparePhotos = _ref => {
  var _indexMap$selectedInd;
  var items = _ref.items,
    selectedIndex = _ref.selectedIndex,
    updateSelectedIndex = _ref.updateSelectedIndex;
  var thumbnails = [];
  var floorplans = [];
  var indexMap = [];
  var handleClick = idx => event => {
    updateSelectedIndex(idx);
    event.stopPropagation();
  };
  items.forEach((item, idx) => {
    var array = item.type === 'FLOORPLAN' ? floorplans : thumbnails;
    var isSelected = selectedIndex === idx;
    indexMap[idx] = item.type === 'FLOORPLAN' ? null : thumbnails.length;
    array.push(___EmotionJSX(Thumbnail, {
      "aria-label": "Go to ".concat(item.type === 'FLOORPLAN' ? 'floorplan' : 'photo', " ").concat(array.length + 1)
      // eslint-disable-next-line react/no-array-index-key
      ,
      key: "".concat(item.title, "-").concat(idx),
      item: item,
      selected: isSelected,
      onClick: logThumbEvent('onClick', handleClick(idx))
    }));
  });
  var selectedThumbnail = (_indexMap$selectedInd = indexMap[selectedIndex]) !== null && _indexMap$selectedInd !== void 0 ? _indexMap$selectedInd : thumbnails.length - 1;
  return {
    thumbnails,
    floorplans,
    selectedThumbnail
  };
};
function countCarouselItems(items) {
  return items.filter(item => item.type === 'PHOTO' || item.type === 'VIDEO' || item.type === 'VIRTUAL_TOUR').length;
}
var Thumbnails = _ref2 => {
  var items = _ref2.items,
    selectedIndex = _ref2.selectedIndex,
    updateSelectedIndex = _ref2.updateSelectedIndex,
    className = _ref2.className;
  var carouselItems = countCarouselItems(items);
  var slider = useRef();
  var _preparePhotos = preparePhotos({
      items,
      selectedIndex,
      updateSelectedIndex
    }),
    thumbnails = _preparePhotos.thumbnails,
    floorplans = _preparePhotos.floorplans,
    selectedThumbnail = _preparePhotos.selectedThumbnail;
  useEffect(() => {
    if (slider.current != null) {
      slider.current.goToSlide(selectedThumbnail);
    }
  }, [selectedThumbnail]);
  var needCarousel = carouselItems > MAX_THUMBNAILS;

  // To fix the key prop issue properly, we need to stop converting the images into <button>s too early.
  /* eslint-disable react/no-array-index-key */
  return ___EmotionJSX("div", {
    className: className,
    css: styles.thumbnails
  }, ___EmotionJSX("div", {
    css: styles.photosList,
    "data-testid": "thumbnails"
  }, ___EmotionJSX("div", {
    css: styles.label
  }, "Photos (", carouselItems, ")"), needCarousel ? ___EmotionJSX(WrapAroundCarousel, {
    css: styles.photos,
    ref: slider,
    decorators: [],
    slidesToShow: MAX_THUMBNAILS,
    cellAlign: "center",
    initialSlideWidth: 52
  }, thumbnails) : ___EmotionJSX("div", {
    css: styles.photos
  }, ___EmotionJSX("ul", null, thumbnails.map(each => ___EmotionJSX("li", {
    css: styles.sliderItem
  }, each))))), floorplans.length > 0 && ___EmotionJSX("div", {
    "data-testid": "floorplan-thumbnails",
    css: styles.floorplanList
  }, ___EmotionJSX("div", {
    css: styles.label
  }, "Floorplan"), ___EmotionJSX("div", {
    css: styles.photos
  }, floorplans)));
};
Thumbnails.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(Item)),
  selectedIndex: PropTypes.number,
  updateSelectedIndex: PropTypes.func,
  className: PropTypes.string
};
Thumbnails.defaultProps = {
  items: [],
  selectedIndex: 0,
  updateSelectedIndex: () => {},
  className: ''
};
export default Thumbnails;